import React from 'react'

import { NavItems, SecondaryNavigation } from 'components/ui/secondary-navigation'

import { space } from 'helpers/style'
import styled from 'styled'
import { mediaQueries } from 'styled/core'

const PageContainer = styled.div`
  min-height: 100vh;
  background-color: ${({ theme }) => theme.color.grayL90};
`

const PrimaryNav = styled.nav`
  flex-grow: 0;
  flex-shrink: 0;
`

const Wrap = styled.div`
  margin: 0 auto;
  max-width: 1600px;
  padding-left: ${space(9)};
  padding-right: ${space(9)};

  ${mediaQueries.lap} {
    padding-left: ${space(18)};
    padding-right: ${space(18)};
  }
`


const Header = styled.header`
  display: flex;
  align-items: center;
  margin: 20px 0;
`

const Heading = styled.h1`
  margin: 0;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

const Main = styled.main`
  display: flex;
  flex-direction: column;
  padding-bottom: ${space(9)};

  ${({ theme }) =>
    `border-top: 1px solid ${theme.color.grayL60};
     padding-top: ${space(9)};`
  }

  ${mediaQueries.hand} {
    flex-direction: row;
  }
`

const Toolbar = styled.div`
  margin-left: auto;
`

const Section = styled.section`
  width: 100%;
`

const Footer = styled.footer`
  position: fixed;
  bottom: 0;
  width: 100%;
`

type Props = {
  readonly nav: () => React.ReactNode;
  readonly title: string;
  readonly toolbar?: () => React.ReactNode;
  readonly subnav: () => React.ReactNode;
  readonly content: () => React.ReactNode;
  readonly footer?: () => React.ReactNode;
};

export const LayoutFullWidthPage = (props: Props) => (
  <PageContainer>
    <PrimaryNav>{props.nav()}</PrimaryNav>
    <div>
      <Wrap>
        <Header>
          <Heading>{props.title}</Heading>
          {props.toolbar && (<Toolbar>{props.toolbar()}</Toolbar>)}
        </Header>
        {props.subnav()}
      </Wrap>
      <Main>
        <Section>
          {props.content()}
        </Section>
      </Main>
    </div>
    {props.footer && (<Footer>{props.footer()}</Footer>)}
  </PageContainer>
)
